import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
	props: ['notification'],
	emits: ['onClickNotification'],
	data() {},
	computed: {
		isAtendimentoValido() {
			return this.notification.fundacao_id || this.notification.cliente_pf_id
				? true
				: false
		},
		iconName() {
			console.log(this.isAtendimentoValido)
			return this.isAtendimentoValido ? 'edit' : 'edit_off'
		},
		dataFormatada() {
			return dayjs(this.notification.data_criacao).format('DD/MM/YYYY HH:mm')
		},
	},
	methods: {
		onClickNotification() {
			if (!this.isAtendimentoValido) return

			this.$emit('onClickNotification', this.notification)
		},
	},
	template: `
        <div class="relative flex items-center gap-8 p-16 border rounded-md border-neutral-30"  >
            <span class="grid w-40 h-40 text-white rounded-full bg-primary-10 place-items-center shrink-0 !self-baseline">
				<svg class="h-24 w-24 !text-primary-pure"  >
					<use xlink:href="#icon_notification_person"></use>
				</svg>
            </span>
            <div class="flex-1">
                    <p class="text-paragraph-1 font-bold text-neutral-100">{{notification.titulo}}</p>
					<p class="text-sm font-medium text-neutral-70 mt-4">Data da Notificação: {{dataFormatada}}</p>
                    <p v-html="notification.descricao" class="mt-16"></p>
            </div>
			<div class="">
				<q-btn :icon="iconName" size="sm" flat color="primary" class="cursor-pointer bg-transparent text-primary-pure" @click="onClickNotification">
                    <q-tooltip v-if="!isAtendimentoValido" class="z-9999 w-max">
                        <q-card class="p-16 shadow-md rounded-md w-max">
                            <span class="text-paragraph-1 text-alert-red-100">
                                Criar tarefa não se aplica para essa notificação.
                            </span>
                            <q-icon name="warning" size="1.5rem" color="alert-red-100"/>
                        </q-card>
                    </q-tooltip>
                </q-btn>	
			</div>																
        </div>
    `,
}
